import $ from 'jquery'

export default {
  name: 'toggle-details',
  props: {
    closeOnOutside: Boolean
  },
  data: () => ({
    opened: false,
    isMounted: false,
    activator: null
  }),
  computed: {
    scope() {
      return {
        toggle: this.toggle,
        opened: this.opened,
        isMounted: this.isMounted,
        activator: this.activator
      }
    }
  },
  watch: {
    opened(val) {
      const type = (options = {}) => {
        const { reverse } = options
        if ((val && !reverse) || (!val && reverse)) {
          return 'opened'
        } else {
          return 'closed'
        }
      }
      
      const toggleElements = $(this.$el).find(`[data-${type()}-text]`)
      toggleElements.each((index, element) => {
        const textNode = $(element).contents().filter((i, el) => {
          return el.nodeType === 3
        })[0]
        const data = $(element).data()
        const currentText = textNode.nodeValue
        const newText = data[`${type()}Text`]
        $(element).data(`${type({ reverse: true })}Text`, currentText)
        $(element).attr(`data-${type({ reverse: true })}-text`, currentText)
        textNode.nodeValue = newText
      })
      if (this.closeOnOutside) {
        if (val) {
          setTimeout(() => {
            $(this.$el).on('click', (e) => {
              console.log('toggle click')
              e.stopPropagation()
            })
            $('body').one('click', this.toggle)
          }, 100)
        } else {
          $(this.$el).off('click', (e) => {
            e.stopPropagation()
          })
          $('body').off('click', this.toggle)
        }
      }
    }
  },
  mounted() {
    this.isMounted = true 
    const openToggleOnLoad = $(this.$el).attr('data-open-on-init') === "true"
    if (openToggleOnLoad) {
       this.toggle(this.$el)
    }
  },
  methods: {
    toggle(e) {
      if (!this.opened) {
        this.activator = e.target
      } else {
        this.activator = null
      }
      this.opened = !this.opened
    }
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}